<template>
	<div>
		<div>武林秘籍：策略分析</div>
		<!-- <SentimentMarketHotTrend  zoom_start="0"></SentimentMarketHotTrend> -->
		<QuantJyJyPool :quant_code="quant_code" title="策略分析" zoom_start="45"></QuantJyJyPool>
	</div>
</template>

<script>
	import QuantJyJyPool from 'components/quant/QuantJyJyPool.vue'
	// import SentimentMarketHotTrend from 'components/sentiment/SentimentMarketHotTrend.vue'
	export default {
		data() {
			return {
				quant_code: 8001,
			}
		},created() {
			const quant_code = this.$route.params.quant || 10 // 如果 URL 参数 dayn 不存在，使用 '10' 作为默认值
			this.quant_code = quant_code
		},
		components: {
			QuantJyJyPool,
			// SentimentMarketHotTrend
		},
		methods: {

		}
	}
</script>

<style>
</style>
